import { Card, Divider, Icon } from "@mui/material";
import ConfirmationModal from "components/ConfirmationModal";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import Pagination from "components/Pagination";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import Table from "components/Tables/Table";
import Loader from "components/loader";
import DashboardLayout from "layouts/DashboardLayout";
import { useEffect, useState } from "react";
import blogListing from "./components/blogListing";
import { closeSnackbar, useSnackbar } from "notistack";
import { APP_CONSTANTS } from "App.constant";
import BlogAddEdit from "./components/blogAddEdit";
import { useNavigate } from "react-router-dom";

function BlogPage() {
    let defaultBlogObject = {
        'blog_category_id': 0,
        'title': '',
        'image': '',
        'image_url': '',
        'image_name': '',
        'description': '',
        'additional_tags': '',
        'custom_script': '',
        'short_description': '',
        'publish_date': '',
        'seo_title': '',
        'seo_keywords': [],
        'seo_description': '',
        'isNewImage': false,
        'status': 1,
        'isPublishDateChange': false,
        'slug': ''
    }
    const [deleteModel, setDeleteModel] = useState(false);
    const [currentBlogData, setCurrentBlogData] = useState(defaultBlogObject);
    const [noBlogImage, setNoBlogImage] = useState('');
    const [addEditSection, setAddEditSection] = useState(false);
    const [allBlogCategories, setAllBlogCategories] = useState([]);
    const [columns, setColumns] = useState([]);
    const [rows, setRows] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [isUpdateData, setIsUpdateData] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const [hasValidationError, setHasValidationError] = useState(false);
    const [validationErrors, setValidationErrors] = useState([]);
    const [searchText, setSearchText] = useState("");

    const USERTYPE = JSON.parse(localStorage.getItem('userData')) ? JSON.parse(localStorage.getItem('userData'))['user_type'] : 0;

    useEffect(() => {
        if (localStorage.getItem('isLoggedIn') === null || localStorage.getItem('isLoggedIn').toString() === 'false') {
            navigate('/', { replace: true });
        }
        getBlogConfigData();
    }, []);

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            getBlogsData(1, searchText);
        }, 500);

        return () => clearTimeout(delayDebounce);
    }, [searchText]);

    const handleEditItem = (data) => {
        setCurrentBlogData(data);
        setIsUpdateData(true);
        setAddEditSection(true);
    };
    const handleDeleteItem = (data) => {
        setCurrentBlogData(data);
        setDeleteModel(true);
    };
    const handleDiscardData = () => {
        setIsUpdateData(false);
        setAddEditSection(false);
        setCurrentBlogData(defaultBlogObject);
        getBlogsData(page);
        setHasValidationError(false);
        setValidationErrors([]);
        closeSnackbar();
    };

    const getBlogConfigData = () => {
        setIsLoading(true);
        const token = "Bearer " + JSON.parse(localStorage.getItem('userData'))['token'];
        fetch(process.env.REACT_APP_API_URL + 'blogs/config-data', {
            method: 'GET',
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": token
            }
        })
            .then(response => response.json())
            .then((responseData) => {
                if (responseData.statusCode === 200) {
                    responseData = responseData.data;
                    setAllBlogCategories(responseData.categories);
                    defaultBlogObject['image_url'] = responseData.no_blog_image;
                    setNoBlogImage(responseData.no_blog_image);
                    getBlogsData(page);
                }
                setIsLoading(false);
            })
            .catch(function (error) {
                setIsLoading(false);
            });
    };
    const getBlogsData = (pageNumber, keyword = "") => {
        setIsLoading(true);
        const token = "Bearer " + JSON.parse(localStorage.getItem('userData'))['token'];
        fetch(process.env.REACT_APP_API_URL + 'blogs/summary?page=' + pageNumber + '&isFront=false&search=' + keyword, {
            method: 'GET',
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": token
            }
        })
            .then(response => response.json())
            .then((responseData) => {
                if (responseData.statusCode === 200) {
                    responseData = responseData.data;
                    const finalBlogData = blogListing(responseData.blogs, handleEditItem, handleDeleteItem, addEditBlog);
                    setColumns(finalBlogData.columns);
                    setRows(finalBlogData.rows);
                    setTotalCount(responseData.totalCount);
                    setTotalPages(Math.ceil(responseData.totalCount / 6));
                }
                setIsLoading(false);
            })
            .catch(function (error) {
                setIsLoading(false);
            });
    };
    const deleteBlog = (blogId) => {
        setIsLoading(true);
        const token = "Bearer " + JSON.parse(localStorage.getItem('userData'))['token'];
        fetch(process.env.REACT_APP_API_URL + 'blogs/delete-blog?id=' + blogId, {
            method: 'DELETE',
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": token
            }
        })
            .then(response => response.json())
            .then((data) => {
                setCurrentBlogData(defaultBlogObject);
                const showMessage = data.message;
                let messageVariant = 'error';
                if (data.statusCode === 200) {
                    setDeleteModel(false);
                    getBlogsData(1);
                    messageVariant = 'success';
                }
                enqueueSnackbar(APP_CONSTANTS.BLOG[showMessage], { variant: messageVariant });
                setIsLoading(false);
            })
            .catch(function (error) {
                setIsLoading(false);
            });
    };
    const addEditBlog = (saveUpdateBlogData = {}) => {
        setIsLoading(true);
        const token = "Bearer " + JSON.parse(localStorage.getItem('userData'))['token'];
        let url = process.env.REACT_APP_API_URL + 'blogs/save-blog';
        let method = "POST";
        if (saveUpdateBlogData.id !== undefined) {
            url = process.env.REACT_APP_API_URL + 'blogs/update-blog';
        }
        let savingData = new FormData();
        [
            'id',
            'title',
            'image',
            'description',
            'publish_date',
            'blog_category_id',
            'additional_tags',
            'custom_script',
            'short_description',
            'seo_title',
            'seo_keywords',
            'seo_description',
            'status',
            'slug'
        ].forEach(key => {
            if (saveUpdateBlogData[key] !== undefined) {
                if (key === 'image') {
                    const blogBlob = new Blob([saveUpdateBlogData[key]]);
                    savingData.append(key, blogBlob, saveUpdateBlogData['image_name']);
                } else if (key === 'seo_keywords') {
                    savingData.append(key, saveUpdateBlogData[key].toString());
                } else {
                    savingData.append(key, saveUpdateBlogData[key] ?? '');
                }
            }
        });
        savingData.append('isNewImage', saveUpdateBlogData['isNewImage'] ?? false);
        savingData.append('isPublishDateChange', saveUpdateBlogData['isPublishDateChange'] ?? false);
        fetch(url, {
            method: method,
            body: savingData,
            headers: {
                "Accept": "application/json",
                "Authorization": token
            }
        })
            .then(response => response.json())
            .then((data) => {
                const showMessage = data.message;
                let messageVariant = 'error';
                if (data.statusCode === 200) {
                    setCurrentBlogData(defaultBlogObject);
                    setIsUpdateData(false);
                    setAddEditSection(false);
                    getBlogsData(1);
                    messageVariant = 'success';
                    setHasValidationError(false);
                    setValidationErrors([]);
                } else {
                    setHasValidationError(true);
                    setValidationErrors(data.data);
                }
                setIsLoading(false);
                enqueueSnackbar(APP_CONSTANTS.BLOG[showMessage], { variant: messageVariant });
            })
            .catch((error) => {
                setIsLoading(false);
            });
    };

    const generateBlogSitemap = () => {
        const url = `${process.env.REACT_APP_API_URL}blogs/sitemap`;
        fetch(url, {
            method: "GET",
            headers: {
                Accept: "application/json",
            },
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.statusCode == 200) {
                    const link = document.createElement("a");
                    link.href = response.data.download_link;
                    link.download = "sitemap.txt";
                    link.target = "_blank";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(response.data.download_link);
                }
            })
            .catch((error) => {
                console.error("Error downloading the file:", error);
            });
    };


    return <>
        <DashboardLayout>
            <DashboardNavbar />
            <ConfirmationModal
                show={deleteModel}
                headerTitle={'Delete Blog'}
                bodyText={'Do you want to delete blog?'}
                closeAction={{
                    color: 'info',
                    title: 'Cancel',
                }}
                confirmAction={{
                    color: 'error',
                    title: 'Confirm',
                }}
                handleClose={() => {
                    setDeleteModel(false);
                    setCurrentBlogData(defaultBlogObject);
                }}
                handleConfirm={() => {
                    setDeleteModel(false);
                    deleteBlog(currentBlogData.id);
                }} />
            <SoftBox py={3}>
                <SoftBox mb={3}>
                    <Card>
                        <SoftBox display="flex" justifyContent="space-between" alignItems="center" alignSelf="flex-end" style={{
                            "margin": "16px 16px 0 16px"
                        }}>
                            <SoftBox width="300px" mr={2}>
                                <input
                                    type="text"
                                    placeholder="Search blogs..."
                                    value={searchText}
                                    onChange={(e) => {
                                        setSearchText(e.target.value);
                                        setPage(1);
                                    }}
                                    style={{
                                        width: "100%",
                                        padding: "8px 12px",
                                        borderRadius: "8px",
                                        border: "1px solid #ccc"
                                    }}
                                />
                            </SoftBox>
                            {
                                !addEditSection ? <>
                                    {
                                        USERTYPE == APP_CONSTANTS.USER_ROLES.ADMIN ?
                                            (<SoftButton variant="gradient" color="secondary" onClick={generateBlogSitemap}>
                                                <Icon fontSize="default" color="inherit">
                                                    web
                                                </Icon>&nbsp;&nbsp;Get Sitemap
                                            </SoftButton>) : (<></>)}
                                    &nbsp;&nbsp;
                                    <SoftButton variant="gradient" color="dark" onClick={() => setAddEditSection(true)}>
                                        <Icon fontSize="default" color="inherit">
                                            add
                                        </Icon>&nbsp;&nbsp;Add Blog
                                    </SoftButton>
                                </> : <>
                                    <SoftButton variant="gradient" color="error" onClick={handleDiscardData}>
                                        <Icon fontSize="default" color="inherit">
                                            close
                                        </Icon>&nbsp;&nbsp; Discard
                                    </SoftButton>
                                    &nbsp;&nbsp;
                                    <SoftButton variant="gradient" color="success" onClick={() => addEditBlog(currentBlogData)}>
                                        <Icon fontSize="default" color="inherit">
                                            check
                                        </Icon>&nbsp;&nbsp; {isUpdateData ? "Update" : "Save"}
                                    </SoftButton>
                                </>
                            }
                        </SoftBox>
                        <Divider flexItem />
                        {
                            !addEditSection ? <>
                                {
                                    !isLoading ? <>
                                        <SoftBox
                                            sx={{
                                                "& .MuiTableRow-root:not(:last-child)": {
                                                    "& td": {
                                                        borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                                                            `${borderWidth[1]} solid ${borderColor}`,
                                                    },
                                                },
                                            }}
                                        >
                                            {
                                                totalCount > 0 ?
                                                    <Table columns={columns} rows={rows} /> :
                                                    <SoftBox display="flex" flexDirection="column" style={{
                                                        "alignItems": "center",
                                                        "margin": "0 16px 16px 16px"
                                                    }}>
                                                        <SoftTypography variant="button" fontWeight="medium">
                                                            No Data Found
                                                        </SoftTypography>
                                                    </SoftBox>
                                            }
                                        </SoftBox>
                                    </> : <>
                                        <Loader classes='black' />
                                    </>
                                }
                                {
                                    !isLoading && totalCount > 0 && <>
                                        <Pagination
                                            maxPages={totalPages}
                                            currentPage={page}
                                            onPageChange={(pageNumber) => {
                                                setPage(pageNumber);
                                                getBlogsData(pageNumber, searchText);
                                            }} />
                                    </>
                                }
                            </> : <>
                                <BlogAddEdit
                                    currentBlogData={currentBlogData}
                                    allBlogCategories={allBlogCategories}
                                    noBlogImage={noBlogImage}
                                    hasValidationError={hasValidationError}
                                    validationErrors={validationErrors} />
                            </>
                        }
                        {
                            addEditSection && <>
                                <Divider flexItem />
                                <SoftBox display="flex" justifyContent="space-between" alignItems="center" alignSelf="flex-end" style={{
                                    "margin": "0 16px 16px 16px"
                                }}>
                                    <>
                                        <SoftButton variant="gradient" color="error" onClick={handleDiscardData}>
                                            <Icon fontSize="default" color="inherit">
                                                close
                                            </Icon>&nbsp;&nbsp; Discard
                                        </SoftButton>
                                        &nbsp;&nbsp;
                                        <SoftButton variant="gradient" color="success" onClick={() => addEditBlog(currentBlogData)}>
                                            <Icon fontSize="default" color="inherit">
                                                check
                                            </Icon>&nbsp;&nbsp; {isUpdateData ? "Update" : "Save"}
                                        </SoftButton>
                                    </>
                                </SoftBox>
                            </>
                        }
                    </Card>
                </SoftBox>
            </SoftBox>
        </DashboardLayout>
    </>;
}

export default BlogPage;